<section class="section white-100">
  <div class="section-container-inside">
    <h2 class="section-heading mar-b-32">
      {{ efficientPanelData?.title }}
    </h2>
    <p class="section-description mar-b-48 align-c">
      <span class="wid-75">
        {{ efficientPanelData?.content.content[0].content[0].value }}
      </span>
    </p>
    <div class="section-efficient-payment">
      <ng-container
        *ngFor="let item of efficientPanelData?.component1; let i = index"
      >
        <div
          class="efficient-payment"
          [ngClass]="
            i === 0
              ? 'blue-100'
              : i === 1
                ? 'padd-32 pink-100'
                : i === 2
                  ? 'padd-32 yellow-100'
                  : ''
          "
        >
          <div
            class="product-landing-content"
            [ngClass]="{ 'padd-32-tr0l': i === 0 }"
          >
            <h5 class="efficient-payment-heading">
              {{ item?.fields?.richTextTitle?.content[0]?.content[0]?.value }}
            </h5>
            <p class="efficient-payment-description">
              {{ item?.fields?.description.content[0].content[0].value }}
            </p>
          </div>
          <figure [ngClass]="{ 'efficient-payment-image': i === 0 }">
            <img
              loading="lazy"
              src="{{ item?.fields?.iconImage?.fields?.file?.url }}"
              alt="{{ item?.fields?.iconImage?.fields?.title }}"
            />
          </figure>
        </div>
      </ng-container>
    </div>
  </div>
</section>
